module.exports = __webpack_public_path__ + "img/beleuchtung_header.c24a596a.jpg";